import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { BetSlipScreen } from '@/feature/betslip-sbk/screens/BetSlip';
import { BetSuccessScreen } from '@/feature/betslip-sbk/screens/BetSuccessScreen';
import { screenPresets } from '@/navigation/screen-presets';
import { BetSlipStackParamList } from '@/navigation/types';
import { common } from '@/styles/styles';

const Stack = createNativeStackNavigator<BetSlipStackParamList>();

export const BetSlipStack = () => (
    <SafeAreaProvider style={common.flex}>
        <Stack.Navigator screenOptions={screenPresets.modalStack}>
            <Stack.Screen name="BetSlipModal" component={BetSlipScreen} />
            <Stack.Screen
                name="BetSuccessScreen"
                component={BetSuccessScreen}
                options={screenPresets.gestureDisabled}
            />
        </Stack.Navigator>
    </SafeAreaProvider>
);
